import { createActions, createReducer } from 'reduxsauce';

// types
const { Types, Creators } = createActions({
  setCustomer: ['customer'],
  resetCustomer: [],
});

const INITIAL_STATE = {};

// reducers
const set = (state, { customer }) => customer;

const reset = () => INITIAL_STATE;

// Hookup reducers to types
const Reducers = createReducer(INITIAL_STATE, {
  [Types.SET_CUSTOMER]: set,
  [Types.RESET_CUSTOMER]: reset,
});

export { Reducers, Types, Creators };
export default Reducers;
